module.exports = __webpack_public_path__ + "img/ico-media.5614c3da.svg";